import { Link } from "react-router-dom";
import { Lockup } from "@/components/Mark";

export default function Footer() {
  const year = new Date().getFullYear();
  const cols = [
    { h: "Product", links: [["/app", "Download"], ["/experts", "Experts"], ["/train", "Train an Expert"], ["/how-it-works", "How it works"]] },
    { h: "Yours", links: [["/library", "My library"], ["/library#recover", "Recover an Expert"]] },
    { h: "Company", links: [["/about", "About"], ["/contact", "Contact"], ["/privacy", "Privacy"]] },
  ];
  return (
    <footer className="border-t border-[color:var(--ex-line)] mt-0">
      <div className="ex-wrap py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="space-y-4">
          <Lockup size={22} />
          <p className="ex-small max-w-xs">
            Private AI that lives on your phone. No account, no cloud, nothing you type ever leaves the device.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.h} className="space-y-3">
            <div className="ex-eyebrow">{c.h}</div>
            <ul className="space-y-2">
              {c.links.map(([to, label]) => (
                <li key={to}><Link to={to} className="ex-small hover:text-white transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="ex-wrap pb-10 flex flex-col sm:flex-row gap-2 sm:items-center justify-between ex-tiny">
        <span>© {year} IP Experts LLC. All rights reserved.</span>
        <span>Made for Android. Runs offline.</span>
      </div>
    </footer>
  );
}
